import { FC, useState } from "react";
import type { BollingerBandsSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "period" | "deviation";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string; min: number; max: number }[] = [
  { key: "period", label: "Period", min: 5, max: 250 },
  { key: "deviation", label: "Deviation", min: 1, max: 50 },
];

interface Props {
  settings: BollingerBandsSettings;
  onChange: (settings: BollingerBandsSettings) => void;
}

export const BollingerBandsInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    period: String(settings.period),
    deviation: String(settings.deviation),
  });

  const handleChange = (key: InputKey, value: string) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleBlur = (key: InputKey, min: number, max: number) => {
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(min, parsed), max);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label, min, max }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={min}
            max={max}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key, min, max)}
          />
        </div>
      ))}
    </div>
  );
};
